// react
import React from "react";

// styles
import useStyles from "./footerStyles";

// mui
import { Typography, Grid } from "@mui/material";

const Footer = () => {
  const classes = useStyles();

  return (
    <div>
      <Grid container className={classes.footer}>
        <Grid
          item
          sx={{
            background: "#1976d2",
            display: "flex",
            justifyContent: "center",
            alignItems : 'center',
            alignItem: "center",
            marginX: "auto",
          }}
        >
          <Typography color="white" sx={{ fontSize: "11px" }}>
            Powered by Fogwing
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footer;
